import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimIncludeAllObjectsToWorkOrderGql } from '../../bimWorkOrderQueries';

const requestId = 'bimIncludeAllObjectsToWorkOrder';

export const useBimIncludeAllObjectsToWorkOrder = (workOrderId: number | undefined, onSuccess: () => any) => {
    const dispatch = useDispatch();

    const [bimIncludeAllObjectsToWorkOrderReset] = useResetStoreData({ requestId });

    const [
        bimIncludeAllObjectsToWorkOrderData,
        bimIncludeAllObjectsToWorkOrderStatus,
        bimIncludeAllObjectsToWorkOrderError,
        bimIncludeAllObjectsToWorkOrderRequest,
    ] = useRequest({
        requestId,
        query: bimIncludeAllObjectsToWorkOrderGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const bimIncludeAllObjectsToWorkOrderMakeRequest = useCallback(
        (constructionTypeId: number) => {
            dispatch(bimIncludeAllObjectsToWorkOrderRequest({ constructionTypeId, workOrderId }));
        },
        [bimIncludeAllObjectsToWorkOrderRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        bimIncludeAllObjectsToWorkOrderReset(undefined);
    }, [bimIncludeAllObjectsToWorkOrderReset]);

    return {
        bimIncludeAllObjectsToWorkOrderData,
        bimIncludeAllObjectsToWorkOrderStatus,
        bimIncludeAllObjectsToWorkOrderError,
        bimIncludeAllObjectsToWorkOrderMakeRequest,
    };
};
